import { landingpage } from './../model/landingpage';
import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { landingpageFailure, landingpageViewFailure, loadLandingPage, saveLandingpage, viewLoadLandingPage, viewSuccessLandingpage } from "../action/landingpage.action";
import { catchError, EmptyError, map, mergeMap, of, switchMap, tap } from "rxjs";
import { MainserviceService } from "src/app/mainservice.service";
import { MatSnackBar } from "@angular/material/snack-bar";


@Injectable()
export class landingpageEffects{
    constructor(private actions$: Actions,private service:MainserviceService,private snackBar:MatSnackBar){

    }
    // addLandingPageEffects$=createEffect(()=>this.actions$.pipe(
    //     ofType(loadLandingPage),
    //     mergeMap(action=>
    //         this.service.saveLandingPage(action.landingpage).pipe(
    //             map((action:any)=>{
    //                 this.snackBar.open('Success', 'Close', { duration: 3000 });
    //               return saveLandingpage({landingpage:action})
    //             }),
    //             catchError((error)=>of(landingpageFailure({error:error.message})))
    //         )
    //     )
    // ))
    addLandingPageEffects$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadLandingPage),
        mergeMap(action =>
          this.service.saveLandingPage(action.landingpage).pipe(
            map((response: any) => {
              this.snackBar.open('Success', 'Close', { duration: 3000 });
              return saveLandingpage({ landingpage: response });
            }),
            catchError(error => of(landingpageFailure({ error: error.message })))
          )
        )
      )
    );

    afterLoadSuccess$ = createEffect(() =>
      this.actions$.pipe(
        ofType(saveLandingpage), // Wait for saveLandingpage action
        map(() => viewLoadLandingPage()) // Dispatch viewLoadLandingPage after success
      )
    );
    viewLandingPage$ = createEffect(() =>
        this.actions$.pipe(
          ofType(viewLoadLandingPage),
          mergeMap(() =>
            this.service.viewLandingPage().pipe(
              map((landingpage:any) => viewSuccessLandingpage({ landingpage:landingpage })),
              catchError(error => of(landingpageViewFailure({ error: error.message })))
            )
          )
        )
      );


}
